import React from 'react'
import cn from 'classnames'

import Icon from './Icon'
import styles from './Bio.module.css'

export default function Bio({ name, role, image, twitter, github, instagram, dribbble }) {
  const backgroundStyle = {
    backgroundImage: `url(${image})`,
  }


  return (
    <div className={cn(styles.container, 'reveal-team')}>
      <div className={styles.photo} style={backgroundStyle} />

      <div className={styles.info}>
        <p className={styles.name}>{name}</p>
        <p className={styles.role}>{role}</p>
      </div>

      <div className={styles.external}>
        {!!twitter && <a href={`https://twitter.com/${twitter}`}>
          <Icon type="twitter" className={styles.twitter} />
        </a>}

        {!!github && <a href={`https://github.com/${github}`}>
          <Icon type="github" className={styles.github} />
        </a>}

        {!!instagram && <a href={`https://instagram.com/${instagram}`}>
          <Icon type="instagram" className={styles.instagram} />
        </a>}

        {!!dribbble && <a href={`https://dribbble.com/${dribbble}`}>
          <Icon type="dribbble" className={styles.dribbble} />
        </a>}
      </div>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Bio.js